import http from '@/utils/ajax'
import { CURRENCYPARAM_INIT_LOADING, CURRENCYPARAM_INIT_SUCCESS, CURRENCYPARAM_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [CURRENCYPARAM_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [CURRENCYPARAM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [CURRENCYPARAM_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  }
}

const actions = {
  async currParamInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.currencyManagement
    commit(CURRENCYPARAM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(CURRENCYPARAM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(CURRENCYPARAM_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
